export default __webpack_public_path__ + "static/media/map_drag_arrows.2fa85d03.png";